module.exports = __webpack_public_path__ + "static/media/iPhone14_6.4692dc34.png";